
import { PublicHealthRecordType } from '../public-health-record-type.model';
import {
    PublicHealthRecordTypeActions, PublicHealthRecordTypeActionTypes
} from './public-health-record-type.actions';

export interface PublicHealthRecordTypeState {
  items: PublicHealthRecordType[];
  loaded: boolean;
}

export const initialState: PublicHealthRecordTypeState = {
  items: [],
  loaded: false,
};

export function publicHealthRecordTypeReducer(state = initialState, action: PublicHealthRecordTypeActions): PublicHealthRecordTypeState {
  switch (action.type) {

    case PublicHealthRecordTypeActionTypes.LoadPublicHealthRecordTypesSuccess:
      return {
        ...state,
        items: action.payload,
        loaded: true
      };

    case PublicHealthRecordTypeActionTypes.LoadPublicHealthRecordTypesFail:
      return {
        ...state,
        loaded: false
      };

    default:
      return state;
  }
}
